const CHANGE_CATALOG_MODE = 'CHANGE_CATALOG_MODE';

export { CHANGE_CATALOG_MODE };



// WEBPACK FOOTER //
// ./src/modules/Catalog/actions/types.js